"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authMiddleware = exports.currentUser = exports.auth = exports.getAuth = exports.buildClerkProps = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./clerkClient"), exports);
var getAuth_1 = require("./getAuth");
Object.defineProperty(exports, "buildClerkProps", { enumerable: true, get: function () { return getAuth_1.buildClerkProps; } });
Object.defineProperty(exports, "getAuth", { enumerable: true, get: function () { return getAuth_1.getAuth; } });
tslib_1.__exportStar(require("./withClerkMiddleware"), exports);
tslib_1.__exportStar(require("./redirect"), exports);
var auth_1 = require("../app-router/server/auth");
Object.defineProperty(exports, "auth", { enumerable: true, get: function () { return auth_1.auth; } });
var currentUser_1 = require("../app-router/server/currentUser");
Object.defineProperty(exports, "currentUser", { enumerable: true, get: function () { return currentUser_1.currentUser; } });
var authMiddleware_1 = require("./authMiddleware");
Object.defineProperty(exports, "authMiddleware", { enumerable: true, get: function () { return authMiddleware_1.authMiddleware; } });
